import React from 'react'
import colors from '../components/colors'
import Footer from '../components/main/Footer'
import AppBar from '../components/main/appBar/AppBar'
import {  Grid } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Payments from '../pages/Payments'
import TopUp from '../pages/TopUp'
import Dashboard from '../components/main/dashboard/Dashboard'
import P2P from '../components/main/P2P/P2P';
import ProfileDetails from '../components/main/myProfile/ProfileDetails';
import Security from '../components/main/myProfile/security/Security';
import Notifications from '../components/main/myProfile/Notifications';
import TransactionHistory from '../components/main/dashboard/latesetTransactions/transactionHistory/TransactionHistory';
import PrivateRoute from '../components/general/PrivateRoute'
import { selectUserInfo } from '../features/userInfo/userInfoSlice';
import { useSelector} from 'react-redux';
import { selectTermsAndConditionsState } from '../features/termsAndConditions/termsAndConditionsSlice'
import OtpPrompt from '../components/main/topUp/cardOnFile/OtpPrompt';
import Pdf from '../components/general/Pdf';
import EventsOverview from '../components/main/events/Events-overview';
import References from '../components/main/inviteFriend/References';
import GeneralView from '../components/main/inviteFriend/GeneralView';
import HowItWorks from '../components/main/inviteFriend/HowItWorks';
import Login from './Login';

const Main = () => {

    const userInfo = useSelector(selectUserInfo)
    const termsAndConditionsSliceState = useSelector(selectTermsAndConditionsState)

    return (
        <Grid container item md={12} xs={12} sx={{ backgroundColor: colors.cyan }}>
            <Grid container item md={12} xs={12} pb={'2%'}>
                <AppBar privacyUrl={termsAndConditionsSliceState.privacyUrl} termsAndConditionsUrl={termsAndConditionsSliceState.termsAndConditionsUrl}/>
            </Grid>
            <Grid item md={12} xs={12} pb={24}>
                <Routes>
                    <Route element={<PrivateRoute/>}>
                        <Route path="*" element={<Login />}/>
                        <Route path="dashboard" element={<Dashboard />}/>
                        <Route index element={<Dashboard />} />
                        <Route path="history" element={<TransactionHistory />} /> 
                        <Route path="onpayments/*" element={<Payments />} />
                        <Route path="topUp/*" element={<TopUp />} />
                        <Route path="p2p/*" element={<P2P />} />
                        <Route path="myProfile" element={<ProfileDetails />} />
                        <Route path="security" element={<Security />} />
                        <Route path="notifications" element={<Notifications />} />
                        <Route path="otpPrompt" element={<OtpPrompt />} />
                        <Route path="pdf" element={<Pdf />} />
                        <Route path="events" element={<EventsOverview />} />
                        <Route path="inviteFriend" element={<GeneralView />} />
                        <Route path="inviteFriend/references" element={<References />} />
                        <Route path="inviteFriend/howItWorks" element={<HowItWorks />} />
                    </Route>
                </Routes>
            </Grid>
            <Grid item md={12} xs={12} >
                <Footer privacyUrl={termsAndConditionsSliceState.privacyUrl} termsAndConditionsUrl={termsAndConditionsSliceState.termsAndConditionsUrl}/>
            </Grid>
        </Grid>

    )
}
export default Main